module.exports = "<p>\n  general-component-for-builder works!\n</p>\n"